<template>
  <div class="custom-container" v-loading.fullscreen.lock="customer.isLoading">
    <el-row v-if="customer.isLoading == false">
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Edit Customer</div>
        </el-col>
      </el-row>
      <el-col :span="24">
        <el-form label-position="left" ref="customer" label-width="175px" :model="customer.data">
          <el-tabs v-model="activeName">
            <el-tab-pane label="Customer Data" name="first">
              <CreateOwner :save="save" :customer="customer.data.customer" />
            </el-tab-pane>
            <el-tab-pane label="Ship/Bill To Address" name="second">
              <CreateSubStore :customer="customer.data.customerAddress" />
            </el-tab-pane>
            <el-tab-pane label="Customer Accounts" name="third">
              <CreateEmploye :save="save" :customer="customer.data" />
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CreateOwner from "./Owner/Create";
import CreateSubStore from "./SubStore/Create";
import CreateEmploye from "./Employe/Create";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    CreateOwner,
    CreateSubStore,
    CreateEmploye
  },
  data: () => ({
    activeName: "first",
    valid: true
  }),
  computed: {
    ...mapState({
      customer: state => state.customer.customer
    })
  },
  methods: {
    ...mapActions({
      getOwner: "customer/GetOwner",
      updateOwner: "customer/UpdateOwner"
    }),
    save(body) {
      const req = {
        params: {
          oracleCustomerId: this.$route.params.id,
          parentId: body[0].userId
        },
        externalUser: body
      };
      this.updateOwner(req);
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getOwner(this.id);
  }
};
</script>

<style></style>
